import { getTmsInstance } from '@adeo/tms-lib';
export const trackingEvent = element => {
  const eventType = element.dataset.trackingEvent;
  if (!eventType) {
    return;
  }
  switch (eventType) {
    case 'buttonClick':
      let overrideButtonName;
      if (element.classList.contains('js-expandButton')) {
        overrideButtonName = element.ariaExpanded === 'true' ? 'see more' : 'see less';
      }
      sendButtonClick({
        ...element.dataset,
        ...(overrideButtonName && {
          buttonName: overrideButtonName
        })
      });
      break;
    case 'fileDownload':
      sendFileDownload(element.dataset.fileName?.trim());
      break;
    case 'mediaDisplay':
      sendMediaDisplay(element.dataset.mediaPosition, element.dataset.mediaType, element.dataset.pictureName);
      break;
    case 'listFilter':
      sendListFilter(element.dataset.filterName, element.dataset.filterValue, element.dataset.filterType);
      break;
  }
};
export const sendButtonClick = dataset => {
  return sendEventData('button.click', dataset);
};
const sendFileDownload = fileName => {
  return sendEventData('file.download', {
    fileName
  });
};
const sendMediaDisplay = (mediaPosition, mediaType, pictureName) => {
  return sendEventData('product_media.display', {
    mediaPosition,
    mediaType,
    pictureName
  });
};
const sendListFilter = (filterName, filterValue, filterType) => {
  return sendEventData('list.filter', {
    filterName,
    filterValue,
    filterType
  });
};
const sendEventData = (eventName, dataset) => {
  const eventData = {
    ...(dataset.buttonName && {
      button_name: dataset.buttonName
    }),
    ...(dataset.label && {
      button_name: dataset.label
    }),
    ...(dataset.buttonLocation && {
      button_location: dataset.buttonLocation
    }),
    ...(dataset.buttonValue && {
      button_value: dataset.buttonValue
    }),
    ...(dataset.buttonType && {
      button_type: dataset.buttonType
    }),
    ...(dataset.featureName && {
      feature_name: dataset.featureName
    }),
    ...(dataset.fileName && {
      file_name: dataset.fileName
    }),
    ...(dataset.mediaPosition && {
      media_position: dataset.mediaPosition
    }),
    ...(dataset.mediaType && {
      media_type: dataset.mediaType
    }),
    ...(dataset.pictureName && {
      picture_name: dataset.pictureName
    }),
    ...(dataset.filterName && {
      filter_name: dataset.filterName
    }),
    ...(dataset.filterValue && {
      filter_value: dataset.filterValue
    }),
    ...(dataset.filterType && {
      filter_type: dataset.filterType
    }),
    ...(dataset.linkDestination && {
      link_destination: dataset.linkDestination
    }),
    product_id: document.querySelector('.js-product-ref')?.innerText || window.tc_vars.cdl_page_resource.id
  };
  try {
    getTmsInstance().pushEvent(window, 'cdl_event', {
      event_name: eventName,
      event_data: eventData
    });
  } catch (e) {
    console.error('Unable to send tracking event', e);
  }
};